module.exports = __webpack_public_path__ + "img/banner_left.1fce098d.jpg";